import React from "react";

import {
    chooseAllExistingStores,
    deselectAllExistingStores,
    selectExistingStores,
    toggleExistingStoreIsSelected
} from "modules/customer/tools/location/cannibalisation/cannibalisationSlice";
import { useAppSelector } from "store";
import MultiSelectFilter from "components/filters/MultiSelectFilter";

const ExistingStoresFilter: React.FC = () => {
    const existingStores = useAppSelector(selectExistingStores);

    return (
        <MultiSelectFilter
            title="Your stores"
            items={existingStores}
            chooseAllItems={chooseAllExistingStores}
            deselectAllItems={deselectAllExistingStores}
            toggleItemIsSelected={toggleExistingStoreIsSelected}
        />
    );
};

export default ExistingStoresFilter;
